<template>
  <el-row class="sorting-part" type="flex" justify="space-between">
    <el-col :xl="12" :lg="12">
      <p class="count-objects">
        <span class="count">{{ count }}</span
        ><span class="count-block-none">{{ title }}</span>
        <span class="count-block-block">об’єктів</span>
      </p>
    </el-col>
    <el-col :xl="12" :lg="12" class="sort-select hidden-xs-only">
      <el-row type="flex" justify="end" align="top">
        <p class="sorting-title">Cортування:</p>
        <el-select
          :value="sortValue"
          @change="$emit('change', $event)"
          popper-class="sorting-select"
        >
          <el-option
            v-for="item in sorting"
            :key="item.id"
            :value="item.id"
            :label="item.title"
            >{{ item.title }}</el-option
          >
        </el-select>
      </el-row>
    </el-col>
    <el-col :xl="12" :lg="12" class="sort-select hidden-sm-and-up ">
      <el-row type="flex" justify="end" align="top">
        <p class="sorting-title">Cортування:</p>
        <el-button
          type="text"
          @click="centerDialogVisible = true"
          class="el-select sorting-select"
          >{{ selectedSortingTitle }}
          <i
            class="el-icon-arrow-right sorting-arrow
"
          ></i
        ></el-button>

        <el-dialog
          :visible.sync="centerDialogVisible"
          width="95%"
          center
          top="23.8vh"
          class="sorting-body-mobile"
        >
          <div class="style-mobile-filter">Сортувати</div>
          <el-row
            v-for="item in sorting"
            :key="item.id"
            class="sorting-body-row-mobile"
          >
            <el-radio
              style="width: 100%"
              v-model="selectedSortingId"
              :label="item.id"
              class="sorting-el-radio"
              >{{ item.title }}</el-radio
            >
          </el-row>
          <span slot="footer" class="dialog-footer">
            <div class="btn-background">
              <el-button
                type="primary"
                @click="submitSorting"
                class="sorting-button"
                >Застосувати</el-button
              >
            </div>
          </span>
        </el-dialog>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { SORTING_LIST } from '@/helper/emptyFilters'

export default {
  name: 'Sorting',
  props: ['count', 'sortValue', 'title'],
  data() {
    return {
      sorting: SORTING_LIST,
      centerDialogVisible: false,
      selectedSortingId: SORTING_LIST[0].id,
    }
  },
  computed: {
    selectedSortingTitle() {
      return this.sorting.find(item => item.id === this.selectedSortingId).title
    },
  },

  methods: {
    submitSorting() {
      this.$emit('change', this.selectedSortingId)
      this.centerDialogVisible = false
    },
  },
}
</script>

<style scoped lang="scss">
@media (max-width: 500px) {
  .sorting-body-mobile {
    &/deep/ {
      .el-dialog--center .el-dialog__body {
        padding: 0;
        padding-bottom: 15px;
      }
    }
  }
  .sorting-el-radio {
    margin: 0;
  }
  .sorting-body-row-mobile {
    padding: 0 15px;
    display: flex;
    align-items: center;
    height: 60px;
    & + & {
      border-top: 1px solid #e3eaef;
    }
  }
  .style-mobile-filter {
    padding: 15px 15px 0px;
  }
}
</style>
